import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { PasswordValidatorModule } from '../shared/directives/password-validator/password-validator.module';
import { AuthRoutingModule } from './auth.routes';
import { NbAuthComponent } from './components/auth.component';
import { RestorePasswordComponent } from './components/change-password/change-password.component';
import { NbLoginComponent } from './components/login/login.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { PMessagesComponent } from '../shared/primeng-helpers/p-messages.component';

@NgModule({
  declarations: [NbAuthComponent, NbLoginComponent, RestorePasswordComponent, SetPasswordComponent],
  imports: [CommonModule, AuthRoutingModule, FormsModule, PMessagesComponent, PasswordValidatorModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class NbAuthModule {}
